import styled from 'styled-components';
import { shakeX } from '../../../../../lib/ui/animations';
import Text from '../../../../../shared/Text';

export const Container = styled.div`
  &.shakeX {
    animation: ${shakeX} 0.8s linear 1;
  }
  @media (prefers-reduced-motion) {
    &.shakeX {
      animation: none;
    }
  }
  border-radius: 8px;
  border: ${props =>
    props.$hasError ? '3px solid #FF9385' : '1px solid #007eff'};
  margin: 20px 0;
  text-align: left;
`;

export const ErrorMsg = styled(Text)`
  display: ${props => (props.$hasError ? 'block' : 'none')};
  margin-top: 5px;
  color: #e93c3c;
`;
